module.exports = __webpack_public_path__ + "static/media/map_us_regions.cc5f5d58.png";